import { render, staticRenderFns } from "./cardManagement.vue?vue&type=template&id=31c4119d&scoped=true&"
import script from "./cardManagement.vue?vue&type=script&lang=js&"
export * from "./cardManagement.vue?vue&type=script&lang=js&"
import style0 from "./cardManagement.vue?vue&type=style&index=0&id=31c4119d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c4119d",
  null
  
)

export default component.exports